export default "__VITE_ASSET__BArx3GeC__"